<template>
  <ul class="article-list">
    <li v-for="article in articles" :key="article.slug">
      <article>
        <div class="meta">
          <span class="category">{{ article.category }}</span>
          <time :datetime="article.published">{{ formatDate(article.published) }}</time>
          <span>{{ article.readingMinutes }} min de lecture</span>
        </div>
        <div class="body">
          <h3><router-link :to="article.path">{{ article.h1 }}</router-link></h3>
          <p>{{ article.description }}</p>
        </div>
      </article>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'ArticleList',
    props: {
      articles: {type: Array, required: true},
    },
    methods: {
      formatDate(iso) {
        return new Date(iso + 'T12:00:00Z').toLocaleDateString('fr-FR', {day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC'});
      },
    },
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.article-list
  list-style none
  margin 0
  padding 0
  border-top 1px solid INK
  li
    margin 0
    padding 0
    border-bottom 1px solid RULE

article
  display grid
  gap 8px 40px
  padding 24px 0

.meta
  display flex
  flex-wrap wrap
  gap 4px 14px
  align-content flex-start
  font-size 0.92rem
  color MUTED
  .category
    font-weight 650
    color INK

h3
  margin 0 0 6px
  font-size clamp(1.25rem, 2.4vw, 1.55rem)
  a
    text-decoration none
    &:hover
      text-decoration underline
      text-decoration-color INK

.body p
  margin 0
  color INK_SOFT
  max-width 68ch

@media (min-width: DESKTOP_SIZE)
  article
    grid-template-columns 230px 1fr
  .meta
    flex-direction column
</style>
